// light gallery
require("lightgallery");
require("lg-thumbnail");
require("lg-fullscreen");
require("lg-autoplay");
require("lg-zoom");


function refreshAdvInsideLightBox() {
  const advSlot = "lightbox-300";
  const destination = ".lg-outer";
  const advSlotId = "div-gpt-ad-" + advSlot;
  const advDiv = '<div id="' + advSlotId + '" style="position: absolute; right: 20px; top: 20px;"></div>';
  $(destination).append($(advDiv));
  PCPrincipal.conditionalTagDisplay(advSlot);
}

export function initLightBox() {
  $(document).ready(function() {
    var $lg = $("#lightgallery");
    var options = {
      selector: ".gallery-image",
      zoom: false
    }
    $lg.lightGallery(options);
    $lg.on('onAfterOpen.lg', refreshAdvInsideLightBox);
  });
}
